import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { getContainerHOC, renderChildren } from '@utils';

import { Translate } from '@decorators';

import { AppStat } from '@common/utils/AppStat';

import { ILandingChildProps, ILandingProps } from './types';

import * as s from './Landing.scss';

@Translate('common.containers.Landing')
export class Landing extends React.Component<ILandingProps> {

	componentDidMount() {
		AppStat.log.boom.openBoomLanding();
	}

	getLocalesText() {
		return {
			terms: this.t('terms'),
			feedback: this.t('feedback'),
			title: this.t('title'),
			descriptionDesktop: this.t('description.desktop'),
			descriptionMobile: this.t('description.mobile'),
		};
	}

	render() {
		const { blockClassName, children } = this.props;
		const {
			landing,
			urls: { terms, feedback },
		} = getConfig();
		const locales = this.getLocalesText();

		return (landing &&
			<div className={cn(s.block, blockClassName)}>
				{renderChildren<ILandingChildProps>(children, {
					landing,
					urls: { terms, feedback },
					locales,
				})}
			</div>
		);
	}

}

export const withShareLandingContainer = getContainerHOC<ILandingProps, ILandingChildProps>(Landing);
